import { call, put, takeLatest } from "redux-saga/effects";
import services from "../../services";

import {
  GET_ONE_QUIZ,
  GET_ONE_QUIZ_SUCCESS,
  GET_ONE_QUIZ_ERROR,
  RESET_GET_ONE_QUIZ,
  initialState as getOneInitialState
} from "../types/quiz/get-one.dto";

import {
  NEW_ANSWER_QUIZ,
  NEW_ANSWER_QUIZ_SUCCESS,
  NEW_ANSWER_QUIZ_ERROR,
  RESET_NEW_ANSWER_QUIZ,
  initialState as newAnswerInitialState
} from "../types/quiz/new-answer-quiz.dto";

function* getOneQuiz({ payload }) {
  try {
    const { response, error } = yield call(services.quiz.getOne, payload);
    if (error) {
      yield put({ type: GET_ONE_QUIZ_ERROR, payload: error });
    } else {
      yield put({
        type: GET_ONE_QUIZ_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: GET_ONE_QUIZ_ERROR,
      payload: "Error al obtener un curso",
    });
  }
}

function* newAnswerQuiz({ payload }) {
  try {
    const { response, error } = yield call(
      services.quiz.newAnswerQuiz,
      payload
    );
    if (error) {
      yield put({ type: NEW_ANSWER_QUIZ_ERROR, payload: error });
    } else {
      yield put({
        type: NEW_ANSWER_QUIZ_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: NEW_ANSWER_QUIZ_ERROR,
      payload: "Error al obtener un quiz",
    });
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(GET_ONE_QUIZ, getOneQuiz);
  yield takeLatest<any>(NEW_ANSWER_QUIZ, newAnswerQuiz);
}
